import React from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

export const TaxIdMask = React.forwardRef(
  ({ name, onChange, ...props }, ref) => (
    <IMaskInput
      {...props}
      mask="###-##-####"
      definitions={{ '#': /[0-9]/ }}
      inputRef={ref}
      onChange={onChange}
      overwrite
    />
  ),
);

TaxIdMask.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
};
